import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AppProvider from "./providers/AppProvider";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Auth0Provider } from "@auth0/auth0-react";
import ErrorBoundary from "./components/ErrorBoundary";
import { ExportProvider } from "./providers/ExportProvider";
import { ExportManager } from "./components/ExportManager/ExportBar";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN!}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
    issuer={process.env.REACT_APP_AUTH0_ISSUER_BASE_URL}
    authorizationParams={{
      redirect_uri: `${window.location.origin}/callback`,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    }}
  >
    {/* // <React.StrictMode> */}
    <Provider store={store}>
      <AppProvider>
        <ExportProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
          <ExportManager />
          <ToastContainer />
        </ExportProvider>
      </AppProvider>
    </Provider>
    {/* // </React.StrictMode> */}
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
